export default __webpack_public_path__ + "static/media/person_1.2a792f33.png";